import { useMemo } from 'react';

export const useCreateSearchParams = searchParamsObj =>
  useMemo(
    () => new URLSearchParams(searchParamsObj).toString(),
    [searchParamsObj],
  );
